export const activity_record_types = {
  JOB: "job",
  CLIENT: "client",
  CANDIDATE: "candidate",
  APPLICATION: "application",
  CUSTOM_ENTITY: "custom_entity",
  AUTOMATION: "automation",
  NOTE: "note",
  CONTACT: "contact",
} as const;